import { Box } from '@mui/material';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { splitLongNames } from 'string-utils';
import { useSnapshot } from 'valtio';
import CollapsiblePanel from '../../elements/CollapsiblePanel/CollapsiblePanel';
import FiltersHeader from '../../elements/FilterBox/FiltersHeader';
import Summary from '../../elements/Summary/Summary';
import {
  clearFilter,
  clearFilters,
  handleSearchFilterType,
  onChangeFilter,
} from '../actions/artifacts-actions';
import ArtifactsSideBar from '../components/SideBar/ArtifactSideBar';
import config from '../config/artifacts-config.json';
import { toggleFiltersPanel } from '../store-actions/artifacts-store-actions';
import ArtifactsStore from '../stores/artifacts-store';

const ArtifactsSideBarContainer: FC = () => {
  const {
    totalFiltered,
    total,
    numberOfFilters,
    filtersOpen,
    loading,
    artifactsFiltersList,
    filterArtifactsBy,
    searchValues,
    artifactsFiltersTypeSearch,
  } = useSnapshot(ArtifactsStore);

  return (
    <CollapsiblePanel
      collapsedSize={config.sidebar.collapsedSize}
      in={filtersOpen}
      togglePanel={toggleFiltersPanel}>
      <ArtifactsSideBar
        disabled={loading.isPending() || loading.isPending()}
        filterList={filterArtifactsBy}
        artifactsFiltersType={artifactsFiltersList}
        onChangeFilter={onChangeFilter}
        totalArtifacts={totalFiltered}
        handleClearFilter={clearFilter}
        searchValues={searchValues}
        artifactsFiltersTypeSearch={artifactsFiltersTypeSearch}
        handleSearchFilterType={handleSearchFilterType}>
        <Summary
          headerText='Artifacts'
          total={total}
          count={totalFiltered}
          onCollapse={toggleFiltersPanel}
          navComponent={NavLink}
        />
        {total !== 0 && (
          <Box py={1}>
            <FiltersHeader
              numberOfFilters={numberOfFilters}
              filterIssuesBy={filterArtifactsBy}
              onResetFilters={clearFilters}
              splitFilterTypeName={splitLongNames}
            />
          </Box>
        )}
      </ArtifactsSideBar>
    </CollapsiblePanel>
  );
};

export default ArtifactsSideBarContainer;
